import { render, staticRenderFns } from "./DashboardV.vue?vue&type=template&id=3ab1648b&scoped=true&"
import script from "./DashboardV.vue?vue&type=script&lang=js&"
export * from "./DashboardV.vue?vue&type=script&lang=js&"
import style0 from "./DashboardV.vue?vue&type=style&index=0&id=3ab1648b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab1648b",
  null
  
)

export default component.exports